import { NgModule } from "@angular/core";
import { Routes, RouterModule } from "@angular/router";
import { ROUTES } from "../../constants";
import { AuthComponent } from "./auth.component";

const routes: Routes = [
	{
		path: ROUTES.ROOT,
		component: AuthComponent
	},
	{
		path: ROUTES.FORGOT_PASSWORD,
		loadChildren: () => import( "../../pages/auth/forgot-password/forgot-password.module" )
			.then( ( module ) => module.ForgotPasswordModule )
	},
	{
		path: ROUTES.INVITATION,
		loadChildren: () => import( "../../pages/auth/invitation/invitation.module" )
			.then( ( module ) => module.InvitationModule )
	},
	{
		path: ROUTES.RESET_PASSWORD,
		loadChildren: () => import( "../../pages/auth/reset-password/reset-password.module" )
			.then( ( module ) => module.ResetPasswordModule )
	},
	{
		path: ROUTES.ACCOUNT_ACTIVATION,
		loadChildren: () => import( "../../pages/auth/account-activation/account-activation.module" )
			.then( ( module ) => module.AccountActivationModule )
	},
	{
		path: ROUTES.WILDCARD,
		redirectTo: ROUTES.LOG_IN
	}
];

@NgModule( {
	imports: [ RouterModule.forChild( routes ) ],
	exports: [ RouterModule ]
} )

export class AuthRoutingModule { }
